/* @ngInject */
const excel = (
  utils,
  valueHandler,
  wagonUtils
) => {
  return (_item, _nature) => {
    if (valueHandler.isNull(_item)) {
      return ''
    }
    if (valueHandler.isEmpty(_item)) {
      return ''
    }

    if (_nature === 'date') {
      if (utils.date.isValidString(_item)) {
        const moment = utils.date.stringToDate(_item)
        return moment.toDate()
      } else if (utils.date.isValidTimestamp(_item)) {
        const moment = utils.date.timestampToDate(_item)
        return moment.toDate()
      } else if (utils.date.isValidDate(_item)) {
        return _item.toDate()
      } else {
        return '-'
      }
    } else if (typeof (_item) === 'boolean' || _nature === 'boolean') {
      return _item ? 'Oui' : 'Non'
    } else if (_nature === 'wagonId') {
      return wagonUtils.idToString(_item)
    } else {
      return _item
    }
  }
}

export default excel



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/entities/excel.filter.js